import { render, staticRenderFns } from "./BookingSuccess.vue?vue&type=template&id=3008dac8"
import script from "./BookingSuccess.vue?vue&type=script&lang=js"
export * from "./BookingSuccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports